/**
 * обработка загрузки фото
 */
import { openModal, findAncestorByAttr } from '../common/utils';
import { Timeout } from '../common/const';

class UploadFiles {
    constructor (block) {
        this.block = block;
        this.queue = this.getQueueByLoad();
        this.templateResult = this.block.querySelector(`[data-preview-tpl]`);
        this.input = this.block.querySelector(`[data-upload-input]`);
        this.labels = this.block.querySelectorAll(`[data-upload-label]`);
        this.numBlock = document.querySelector(`[data-upload-length=${this.input.getAttribute(`id`)}]`);
        this.fileList = this.block.querySelector(`[data-img-grid]`);
        this.size = parseInt(this.input.getAttribute(`data-size`), 10);
        this.limit = this.input.getAttribute(`data-limit`) || 10;
        this.isMultiple = this.input.hasAttribute(`multiple`);
        this.modal = this.block.querySelector(`[data-upload-modal]`);
        this.cropper = null;
        this.canvas = null;
        this.deleteFile = this.deleteFile.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.savePhoto = this.savePhoto.bind(this);
    }

    onLoad() {
        this.fileList.querySelector(`[data-preview-tpl]`).remove();
    }

    getQueueByLoad() {
        const results = this.block.querySelectorAll(`.file-input__result`);
        let queue = [];
        results.forEach((result) => {
           if (result.getAttribute(`data-id`)) {
               queue.push(result.getAttribute(`data-id`));
           }
        });
        return queue;
    }

    // добавить превью файлов
    addFileResult(event, file) {
        if (this.queue.includes(file.name)) return;
        const preview = this.templateResult.cloneNode(true);
        preview.classList.remove(`template`);
        if (preview.querySelector(`img`)) preview.querySelector(`img`).src = event.target.result;
        if (preview.querySelector(`.text`)) preview.querySelector(`.text`).textContent = file.name;

        preview.setAttribute(`data-id`, file.name);
        preview.removeAttribute(`id`);

        const files = this.fileList.querySelectorAll(`[data-id]`);

        if (!this.isMultiple && files.length) {
            for (let file of files) {
                file.remove();
            }
        }

        this.fileList.prepend(preview);
        this.queue.push(file.name);
        this.changeFilesNum();
    }

    // скрыть кнопки загрузки файлов
    hideLabels() {
        for (let label of this.labels) {
            label.style.display = `none`;
        }
    }

    // показать кнопки загрузки файлов
    showLabels(block) {
        const labels = block.querySelectorAll(`[data-upload-label]`);
        for (let label of labels) {
            label.style.display = ``;
        }
    }

    // изменить количество загруженных файлов
    changeFilesNum() {
        if (this.numBlock) {
            this.numBlock.textContent = `${this.queue.length} из ${this.limit}`;
        }
    }

    // сохранить отредактированное фото
    savePhoto(reader, event) {
        this.hideLabels();

        this.canvas = this.cropper.getCroppedCanvas({
            width: 400, height: 400
        });

        this.canvas.toBlob((blob) => {
            // let url = URL.createObjectURL(blob);
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                let base64data = reader.result;
                this.addFileResult(event, base64data);
                $.fancybox.close();
            }
        });
    }

    // открыть модалку (если есть)
    initModal(event, reader) {
        const attr = this.modal.getAttribute(`data-upload-modal`);
        const modalBlock = document.querySelector(attr);
        const submitBtn = modalBlock.querySelector(`[data-upload-submit]`);
        const _this = this;

        openModal(modalBlock, {
            afterLoadCb: (instance, el) => {
                const img = modalBlock.querySelector(`img`);
                img.setAttribute(`src`, event.target.result);

                _this.cropper = new Cropper(img, {
                    aspectRatio: 1
                });

                setTimeout(() => {
                    el.$content.addClass(`animation`);
                }, Timeout.SHORT_TIMEOUT);
            },
            beforeClose: (instance, el) => {
                _this.cropper.destroy();
                _this.cropper = null;
                _this.canvas = null;

                el.$content.removeClass(`animation`);
            },
            afterClose: (instance, el) => {
                submitBtn.removeEventListener(`click`, clickHandler);
            }
        });

        function clickHandler() {
            _this.savePhoto(reader, event);
        }

        // Сохранить фото из модалки
        submitBtn.addEventListener(`click`, clickHandler);
    }

    // показ превью файла
    showFilePreview(file) {
        const reader = new FileReader();

        reader.addEventListener(`load`, (event) => {
            if (this.modal) {
                this.initModal(event, reader);
            } else {
                this.addFileResult(event, file);
            }
        });

        reader.readAsDataURL(file);
    }

    // удалить файл
    deleteFile(target) {
        const item = findAncestorByAttr(target, `data-preview-tpl`);
        const block = findAncestorByAttr(target, `data-upload-files`);
        const id = item.getAttribute(`data-id`);
        let index = this.queue.indexOf(id);
        if (index !== -1) {
            this.queue.splice(index, 1);
        }
        item.remove();
        if (block) this.showLabels(block);
        this.changeFilesNum();
    }

    // загрузка файла
    uploadFile(target) {
        const files = target.files;

        if ((files.length + this.queue.length) > this.limit) {
            $(target).closest(`[data-validation-form]`).valid();
            target.value = ``;
            return;
        }

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            if ((file.size > this.size) || (!file.type.match(/image\/(jpeg|jpg|png)/))) {
                $(target).valid();
                target.value = ``;
                return;
            }

            if (!this.isMultiple && !this.modal) this.hideLabels();
            this.showFilePreview(files[i]);
        }
    }

    // обрабочики событий
    init() {
        this.input.addEventListener(`change`, e => {
            const target = e.target;
            if (target === target.closest(`[data-upload-input]`)) { // загрузка фото
                if (target.type === `file`) {
                    this.uploadFile(target);
                }
            }
        });

        document.addEventListener(`click`, e => {
            const target = e.target;
            // удаление файла
            if (target === target.closest(`[data-file-delete]`) && findAncestorByAttr(target, `data-upload-files`) === this.block) {
                this.deleteFile(target);
            }
        });
    }
}

/**
 * загрузка файлов с превью
 */
export const initPhotosInput = () => {
    const blocks = document.querySelectorAll(`[data-upload-files]`);
    blocks.forEach(block => {
        new UploadFiles(block).init();
    });
};
